<template>
    <transition>
        <form v-if="detect == 'pc'" ref="form" name="KSPayWeb" action = "./kspay_wh_result.php" method=post>
            <!-- <Part 1. KSPayWeb Form: 결과페이지주소 설정 > -->
            <!--결제 완료후 결과값을 받아처리할 결과페이지의 주소-->
            <!--
            sndPayMethod
            1000000000: 신용카드
            0100000000: 가상계좌
            0010000000: 계좌이체
            0001000000: 월드패스카드
            0000100000: 문화상품권
            0000010000: 휴대폰결제
            0000001000: 게임문화상품권 -->

            <input type="hidden" name="sndPayMethod" value="1000000000">
            <!-- 테스트용 아이디: 2999199999 (테스트이후 실제발급아이디로 변경)-->
            <input v-model="siteCd" type='hidden' name='sndStoreid' value='2999199999' size='15' maxlength='10'>
            <!--주문번호는 50Byte(한글 25자) 입니다. ' " ` 는 사용하실수 없습니다. 따옴표,쌍따옴표,백쿼테이션 -->
            <input v-model="orderNo" type='hidden' name='sndOrdernumber' value='carrot_1234' size='30'>

            <!--옵션정보 : 옵션 사항 입니다. 설정 안하거나 값을 보내지 않을경우 default 값으로 설정됩니다.-->
            <!--상품명 50Byte(한글 25자) 입니다. ' " ` 는 사용하실수 없습니다. 따옴표,쌍따옴표,백쿼테이션 -->
            <input v-model="orderName" type='hidden' name='sndGoodname' value='당근10kg' size='30'>
            <!--금액은 ,없이 입력 -->
            <input v-model="amount" type='hidden' name='sndAmount' value='1004' size='15' maxlength='9'>
            <!-- 결제자 -->
            <input v-model="buyerName" type='hidden' name='sndOrdername' value='김토끼' size='30'>
            <!--KSPAY에서 결제정보를 메일로 보내줍니다.(신용카드거래에만 해당)-->
            <input v-model="buyerEmail" type='hidden' name='sndEmail' value='kspay@carrot.co.kr' size='30'>
            <!--전화번호 value 값에 숫자만 넣게 해주시길 바랍니다. : '-' 가 들어가면 안됩니다.-->
            <input type='hidden' name='sndMobile' :value="(buyerPhone || '').replace(/[^0-9]/g, '')" size='12' maxlength='12'>

            <!-- 추가 파라미터 메뉴얼 참조-->
            <input type=hidden  name=sndServicePeriod  value=""> <!-- 실제 배송상품이아닌 컨텐츠상품시 제공기간표시 -->
            <!-- <Part 2. 추가설정항목(메뉴얼참조)> -->

            <!-- 0. 공통 환경설정 -->
            <input type=hidden	name=sndReply value="">
            <input type=hidden  name=sndGoodType value="2"> 	<!-- 상품유형: 실물(1),디지털(2) -->

            <!-- 1. 신용카드 관련설정 -->

            <!-- 신용카드 결제방법  -->
            <!-- 일반적인 업체의 경우 ISP,안심결제만 사용하면 되며 다른 결제방법 추가시에는 사전에 협의이후 적용바랍니다 -->
            <input type=hidden  name=sndShowcard value="I,M"> <!-- I(ISP), M(안심결제), N(일반승인:구인증방식), A(해외카드), W(해외안심)-->

            <!-- 신용카드(해외카드) 통화코드: 해외카드결제시 달러결제를 사용할경우 변경 -->
            <input type=hidden	name=sndCurrencytype value="WON"> <!-- 원화(WON), 달러(USD) -->

            <!-- 할부개월수 선택범위 -->
            <!--상점에서 적용할 할부개월수를 세팅합니다. 여기서 세팅하신 값은 결제창에서 고객이 스크롤하여 선택하게 됩니다 -->
            <!--아래의 예의경우 고객은 0~12개월의 할부거래를 선택할수있게 됩니다. -->
            <input type=hidden	name=sndInstallmenttype value="ALL(0:2:3:4:5:6:7:8:9:10:11:12)">

            <!-- 가맹점부담 무이자할부설정 -->
            <!-- 카드사 무이자행사만 이용하실경우  또는 무이자 할부를 적용하지 않는 업체는  "NONE"로 세팅  -->
            <!-- 예 : 전체카드사 및 전체 할부에대해서 무이자 적용할 때는 value="ALL" / 무이자 미적용할 때는 value="NONE" -->
            <!-- 예 : 전체카드사 3,4,5,6개월 무이자 적용할 때는 value="ALL(3:4:5:6)" -->
            <!-- 예 : 삼성카드(카드사코드:04) 2,3개월 무이자 적용할 때는 value="04(3:4:5:6)"-->
            <!-- <input type=hidden	name=sndInteresttype value="10(02:03),05(06)"> -->
            <input type=hidden	name=sndInteresttype value="NONE">

            <!-- 2. 온라인입금(가상계좌) 관련설정 -->
            <input type=hidden	name=sndEscrow value="1"> 			<!-- 에스크로사용여부 (0:사용안함, 1:사용) -->

            <!-- 3. 월드패스카드 관련설정 -->
            <input type=hidden	name=sndWptype value="1">  			<!--선/후불카드구분 (1:선불카드, 2:후불카드, 3:모든카드) -->
            <input type=hidden	name=sndAdulttype value="1">  		<!--성인확인여부 (0:성인확인불필요, 1:성인확인필요) -->

            <!-- 4. 계좌이체 현금영수증발급여부 설정 -->
            <input type=hidden  name=sndCashReceipt value="0">          <!--계좌이체시 현금영수증 발급여부 (0: 발급안함, 1:발급) -->

            <!-- 5. 상품권, 게임문화상품권 관련 설정 -->
            <input type=hidden  name=sndMembId value=""> <!-- 가맹점사용자ID (문화,게임문화 상품권결제시 필수) -->

            <!-- <Part 3. 승인응답 결과데이터> -->
            <!-- 결과데이타: 승인이후 자동으로 채워집니다. (*변수명을 변경하지 마세요) -->

            <input type=hidden name=reWHCid 	value="">
            <input type=hidden name=reWHCtype 	value="">
            <input type=hidden name=reWHHash 	value="">

            <!--업체에서 추가하고자하는 임의의 파라미터를 입력하면 됩니다.-->
            <!--이 파라메터들은 지정된결과 페이지(kspay_result.php)로 전송됩니다.-->
            <input type=hidden name=a        value="a1">
            <input type=hidden name=b        value="b1">
            <input type=hidden name=c        value="c1">
            <input type=hidden name=d        value="d1">

            <button v-bind:id="'ksnet-pay-button'" type="button" value="결 제" v-on:click="pay();" style="display: none;">결제</button>
        </form>

        <form v-if="detect == 'mobile'" ref="form" name="authFrmFrame" method=post accept-language="utf-8" accept-charset="utf-8">
            <!-- <Part 1. authFrmFrame Form: 결과페이지주소 설정 > -->
            <!--결제 완료후 결과값을 받아처리할 결과페이지의 주소-->
            <!-- 결과값 수신 파라메터, value값을 채우지마십시오. KSPayRcv.asp가 실행되면서 채워주는 값입니다-->

            <!-- < Part 2. 고객에게 보여지지 않는 항목 > -->
            <!--이부분은 결제를 위해 상점에서 기본정보를 세팅해야 하는 부분입니다.														-->
            <!--단 고객에게는 보여지면 안되는 항목이니 테스트 후 필히 hidden으로 변경해주시길 바랍니다.									-->
            <!--
            1000000000 : 신용카드
            0100000000 : 가상계좌
            0010000000 : 계좌이체
            0000010000 : 휴대폰결제 -->
            <input type="hidden" name="sndPaymethod" value="1000000000">
            <!-- 상점아이디 -->
            <input v-model="siteCd" type=hidden name=sndStoreid size=10 maxlength=10 value="2999199999">
            <!-- 화폐단위 원화로 설정 : 410 또는 WON -->
            <input type=hidden name=sndCurrencytype size=30 maxlength=3 value="WON">
            <!--상품명은 30Byte(한글 15자) 입니다. 특수문자 ' " - ` 는 사용하실수 없습니다. 따옴표,쌍따옴표,빼기,백쿼테이션 -->
            <input v-model="orderNo" type=hidden name=sndOrdernumber size=30 maxlength=30 value="carrot_1234">
            <!--주민등록번호는 필수값이 아닙니다.-->
            <input type=hidden name=sndAllregid size=30 maxlength=13 value="">
            <!--상점에서 적용할 할부개월수를 세팅합니다. 여기서 세팅하신 값은 KSPAY결재팝업창에서 고객이 스크롤선택하게 됩니다 -->
            <!--아래의 예의경우 고객은 0~12개월의 할부거래를 선택할수있게 됩니다. -->
            <input type=hidden name=sndInstallmenttype size=30 maxlength=30 value="0:2:3:4:5:6:7:8:9:10:11:12">
            <!--무이자 구분값은 중요합니다. 무이자 선택하게 되면 상점쪽에서 이자를 내셔야합니다.-->
            <!--무이자 할부를 적용하지 않는 업체는 value='NONE" 로 넘겨주셔야 합니다. -->
            <!--예 : 모두 무이자 적용할 때는 value="ALL" / 무이자 미적용할 때는 value="NONE" -->
            <!--예 : 3,4,5,6개월 무이자 적용할 때는 value="3:4:5:6" -->
            <input type=hidden name=sndInteresttype size=30 maxlength=30 value="NONE">
            <!-- 신용카드표시구분 -->
            <input type=hidden name=sndShowcard size=30 maxlength=30 value="I,M">
            <!-- <Part 3. 고객에게 보여주는 항목 > ->

            <!-- 상품명은 30Byte(한글 15자)입니다. 특수문자 ' " - ` 는 사용하실수 없습니다. 따옴표,쌍따옴표,빼기,백쿼테이션 -->
            <input v-model="orderName" type=hidden name=sndGoodname size=30 maxlength=30 value="당근10kg">
            <input v-model="amount" type=hidden name=sndAmount size=30 maxlength=9 value="1003">
            <input v-model="buyerName" type=hidden name=sndOrdername size=30 maxlength=20 value="김토끼">
            <!--KSPAY에서 결제정보를 메일로 보내줍니다.(신용카드거래에만 해당)-->
            <input v-model="buyerEmail" type=hidden name=sndEmail size=30 maxlength=50 value="kspay@carrot.do.kr">
            <!--카드사에 SMS 서비스를 등록하신 고객에 한해서 SMS 문자메세지를 전송해 드립니다.-->
            <!--전화번호 value 값에 숫자만 넣게 해주시길 바랍니다. : '-' 가 들어가면 안됩니다.-->
            <input type=hidden name=sndMobile size=30 maxlength=12 :value="(buyerPhone || '').replace(/[^0-9]/g, '')">

            <input type=hidden name=sndReply           		value="">
            <input type=hidden name=sndEscrow          	value="0">	  				<!--에스크로적용여부-- 0: 적용안함, 1: 적용함 -->
            <input type=hidden name=sndVirExpDt     		value="">      			<!-- 마감일시 -->
            <input type=hidden name=sndVirExpTm     		value="">      			<!-- 마감시간 -->
            <input v-model="siteNameKo" type=hidden name=sndStoreName       	value="케이에스페이(주)">   <!--회사명을 한글로 넣어주세요(최대20byte)-->
            <input v-model="siteNameEn" type=hidden name=sndStoreNameEng    	value="kspay_test_store">   <!--회사명을 영어로 넣어주세요(최대20byte)-->
            <input v-model="siteUrl" type=hidden name=sndStoreDomain      value="">   <!-- 회사 도메인을 http://를 포함해서 넣어주세요-->
            <input type=hidden name=sndGoodType		   		value="2">								<!--실물(1) / 디지털(2) -->
            <input type=hidden name=sndUseBonusPoint		value="">   							<!-- 포인트거래시 60 -->
            <input type=hidden name=sndRtApp		   			value="">									<!-- 하이브리드APP 형태로 개발시 사용하는 변수 -->

            <input v-bind:id="'ksnet-pay-button'" type="button" value=" 지 불 " v-on:click="pay();" style="display: none;">
        </form>
    </transition>
</template>

<script>
import detect from "@/plugins/detect";

export default{
    props: {
        siteNameKo: { type: String, default: null },
        siteNameEn: { type: String, default: null },
        siteUrl: { type: String, default: `${window.location.protocol}//${window.location.hostname}` },
        siteCd: { type: String, default: "2010600009" },

        orderNo: { type: String, default: null },
        orderName: { type: String, default: null },
        amount: { type: Number, default: 0 },

        buyerName: { type: String, default: null },
        buyerEmail: { type: String, default: null },
        buyerPhone: { type: String, default: null }
    },
    data(){
        return {
            detect
        };
    },
    methods: {
        created(){
            if(!window.goResult){
                window.goResult = this.redirect;
            }
        },
        pay(){
            this.$nextTick(() => {
                // sndReply는 kspay_wh_rcv.php (결제승인 후 결과값들을 본창의 KSPayWeb Form에 넘겨주는 페이지)의 절대경로를 넣어줍니다.
                // this.$refs.form.sndReply.value = this.getLocalUrl("kspay_wh_result.php") ;
                if(this.detect == "pc"){
                    // this.$refs.form.sndReply.value = this.getLocalUrl("kspay_wh_rcv.php");
                    this.$refs.form.sndReply.value = `${this.resultUrl}/pc`;

                    var agent = navigator.userAgent;
                    var midx		= agent.indexOf("MSIE");
                    var out_size	= (midx != -1 && agent.charAt(midx+5) < '7');

                    var width_	= 500;
                    var height_	= out_size ? 568 : 518;
                    var left_	= screen.width;
                    var top_	= screen.height;

                    left_ = left_/2 - (width_/2);
                    top_ = top_/2 - (height_/2);

                    var op = window.open('about:blank','AuthFrmUp','height='+height_+',width='+width_+',status=yes,scrollbars=no,resizable=no,left='+left_+',top='+top_+'');

                    if (op == null)
                    {
                        alert("팝업이 차단되어 결제를 진행할 수 없습니다.");
                        return false;
                    }

                    this.$refs.form.target = 'AuthFrmUp';
                    this.$refs.form.action ='https://kspay.ksnet.to/store/KSPayFlashV1.3/KSPayPWeb.jsp?sndCharSet=utf-8';
                    //_frm.action ='http://210.181.28.116/store/KSPayFlashV1.3/KSPayPWeb.jsp?sndCharSet=utf-8';

                    this.$refs.form.submit();
                }
                if(this.detect == "mobile"){
                    this.$refs.form.sndReply.value = `${this.resultUrl}/mobile`;

                    var agent = navigator.userAgent;
                    var midx		= agent.indexOf("MSIE");
                    var out_size	= (midx != -1 && agent.charAt(midx+5) < '7');
                    this.$refs.form.action ='http://kspay.ksnet.to/store/mb2/KSPayPWeb_utf8.jsp';
                    this.$refs.form.submit();
                }
            });
        },
    },
    computed: {
        resultUrl(){
            return `${this.siteUrl}/api/v1/shop/orders/validate/ksnet`;
        }
    }
}
</script>
